function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import coreStore from '@signiapp/core/store';
var MODULE_NAME = 'contact';

var getTranslations = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name, lang) {
    var state, core, _core$app$config$text, baseUrl, accountId;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = coreStore.getState();
            core = state.core;
            _core$app$config$text = core.app.config.textApi, baseUrl = _core$app$config$text.baseUrl, accountId = _core$app$config$text.accountId;
            return _context.abrupt("return", fetch("".concat(baseUrl, "/dictionaries?translationKeyGroupName=signiapp-module-").concat(name, "&language=").concat(lang, "&accountId=").concat(accountId)).then(function (result) {
              return result.json();
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getTranslations(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export var getDictionary = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(language) {
    var dictionary;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getTranslations(MODULE_NAME, language);

          case 2:
            dictionary = _context2.sent;
            return _context2.abrupt("return", dictionary);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getDictionary(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
export default {
  getDictionary: getDictionary
};